var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qualifying-controls clearfix"},[_c('button',{class:[
      'control',
      'control-one-third',
      'decide-button',
      'fail-button',
      { fail: _vm.decision === 'fail' }
    ],on:{"click":function($event){$event.preventDefault();_vm.decision = 'fail'}}},[_c('span',[_vm._v(_vm._s(_vm.lang.get('qualifying.controls.fail')))]),_vm._v(" "),_c('i',{staticClass:"af-icons af-icons-cross"})]),_vm._v(" "),_c('button',{class:[
      'control',
      'control-one-third',
      'decide-button',
      'pass-button',
      { pass: _vm.decision === 'pass' }
    ],on:{"click":function($event){$event.preventDefault();_vm.decision = 'pass'}}},[_c('span',[_vm._v(_vm._s(_vm.lang.get('qualifying.controls.pass')))]),_vm._v(" "),_c('i',{staticClass:"af-icons af-icons-tick"})])])}
var staticRenderFns = []

export { render, staticRenderFns }